export default __webpack_public_path__ + "static/media/apple.b24cb20f.JPG";